var current_scroll_position = 0;

function playVideo(data_str)
{
    //data str may be like
    // youtube:https://www.youtube.com/watch?v=0-5coQOqjoU
    // vimeo:https://vimeo.com/1121290477    
    var temp_arr = data_str.split(":");
    if(temp_arr[1]!='')
    {
        html = '';
        if(temp_arr[0]=='youtube')
        {
            new_arr = data_str.split("watch?v=");
            if(new_arr[1]==undefined || new_arr[1]=='')
            {
                new_arr = data_str.split("shorts/");
            }
            html =`<iframe src="https://www.youtube.com/embed/${new_arr[1]}?enablejsapi=1&autoplay=1&controls=1&mute=1&rel=0" title="YouTube video player" id="iframe_video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }
        else
        {
            new_arr = data_str.split("vimeo.com/");
            html =`<iframe src="https://player.vimeo.com/video/${new_arr[1]}?background=0&autoplay=1&title=true&muted=1" title="Vimeo Video Player" id="iframe_video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        }

        if(html!='')
        {
            $('.edu-video-modal__player').html(html)
            current_scroll_position = $(document).scrollTop();
            $('.edu-video-modal').css('visibility','visible');
            $('body').css('overflow', 'hidden');
        }
    }
}

function GetQueryStringParams(sParam)
{
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

   	for (var i=0;i<sURLVariables.length;i++)
   	{
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        {
            return sParameterName[1];
        }

    }
 }

$(document).ready(() => {
    var section_anchor = GetQueryStringParams('section');

    if(section_anchor!=undefined)
    {
        scroll_to= $('[data-edu-section="'+section_anchor+'"]').position().top -130;
        $('body,html').animate({
            scrollTop: scroll_to},
            'fast'
        );
    }


    $('[data-anchor]').on('click',function(){          
        scroll_to= $('[data-edu-section="'+$(this).data('anchor')+'"]').position().top -105;
        $('body,html').animate({
            scrollTop: scroll_to},
            'fast'
        );
    });
    //play video
    $('[data-edu-video]').click(function(){
        
        var str = $(this).data('edu-video');

        if(str!=undefined && str!='')
        {
            playVideo(str);
        }
    });
    
    //close video modal when click on X button
    $('[data-edu-video-close]').click(function(){
        $('.edu-video-modal__player').html('');
        $('.edu-video-modal').css('visibility','hidden');
        $('body').css('overflow', 'auto');
        window.scrollTo(0, current_scroll_position);

        var iframe = document.getElementById('iframe_video_hero');

        if(iframe)
        {
            if($('.edu-video-modal').attr('data-video-type')=="vimeo")
            {
                var player = new Vimeo.Player(iframe);
                player.play();
            }
            else
            {
                player1.playVideo();
            }
        }
    });

    //close video modal when ESCAPE key pressed
    $(document).keydown(function(e) {
        var code = e.keyCode || e.which;
        
        if (code == 27){
            $('.edu-video-modal__player').html('');
            $('.edu-video-modal').css('visibility','hidden');
            $('body').css('overflow', 'auto');
            window.scrollTo(0, current_scroll_position);

            var iframe = document.getElementById('iframe_video_hero');

            if(iframe)
            {
                if($('.edu-video-modal').attr('data-video-type')=="vimeo")
                {
                    var player = new Vimeo.Player(iframe);
                    player.play();
                }
                else $('.edu-video-modal').attr('data-video-type')=="youtube"
                {
                    player1.playVideo();
                }
            }
        }
    });
});